import { useCallback, useEffect, useRef, useState } from 'react';
export const useInViewOnce = function (_temp) {
  let _ref = _temp === void 0 ? {} : _temp,
    onVisible = _ref.onVisible,
    _ref$threshold = _ref.threshold,
    threshold = _ref$threshold === void 0 ? 0.5 : _ref$threshold,
    _ref$enabled = _ref.enabled,
    enabled = _ref$enabled === void 0 ? true : _ref$enabled,
    resetKey = _ref.resetKey;
  const _useState = useState(null),
    node = _useState[0],
    setNode = _useState[1];
  const hasFiredRef = useRef(false);
  const onVisibleRef = useRef(onVisible);
  useEffect(() => {
    onVisibleRef.current = onVisible;
  });
  useEffect(() => {
    hasFiredRef.current = false;
  }, [resetKey]);
  useEffect(() => {
    if (!node || !enabled || hasFiredRef.current || typeof IntersectionObserver === 'undefined') {
      return undefined;
    }
    const observer = new IntersectionObserver(entries => {
      if (hasFiredRef.current || !entries.some(entry => entry.isIntersecting)) {
        return;
      }
      hasFiredRef.current = true;
      observer.disconnect();
      onVisibleRef.current == null || onVisibleRef.current();
    }, {
      threshold
    });
    observer.observe(node);
    return () => observer.disconnect();
  }, [node, enabled, threshold, resetKey]);
  return useCallback(next => setNode(next), []);
};
//# sourceMappingURL=useInViewOnce.js.map